<div class="page-wrapper">
    @if (isCallInProgress()) {
        <sfx-loader class="no-flex-grow"></sfx-loader>
    }
    @if (didCallFail()) {
        <div class="redirect-container mad-list mad--vertical">
            <sfx-info
                type="danger"
                text="key4_training_completed.failed.title"
            ></sfx-info>
            <sfx-button
                type="main"
                label="key4_training_completed.failed.retry"
                (clicked)="retryCall()"
            ></sfx-button>
            @if (hasWaitedAnExtendedPeriod()) {
                <sfx-button
                    type="main"
                    label="auth.redirect_to_projects.button"
                    (clicked)="redirectToProjects()"
                ></sfx-button>
            }
        </div>
    }
</div>
